"use client";
import {
  useSeparator
} from "./YZEJGRDQ.js";
import {
  useCompositeContext
} from "./IB7YUKH5.js";
import {
  createComponent,
  createElement,
  createHook
} from "./3ORBWXWF.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "./4R3V3JGP.js";

// src/composite/composite-separator.ts
import { invariant } from "@ariakit/core/utils/misc";
var useCompositeSeparator = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useCompositeContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "CompositeSeparator must be wrapped in a Composite component."
    );
    const orientation = store.useState(
      (state) => state.orientation === "horizontal" ? "vertical" : "horizontal"
    );
    props = useSeparator(__spreadProps(__spreadValues({}, props), { orientation }));
    return props;
  }
);
var CompositeSeparator = createComponent(
  (props) => {
    const htmlProps = useCompositeSeparator(props);
    return createElement("hr", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  CompositeSeparator.displayName = "CompositeSeparator";
}

export {
  useCompositeSeparator,
  CompositeSeparator
};
